module.exports = __webpack_public_path__ + "img/ring_y_skip_0_null@2x.d2e61347.png";